import React, { useEffect, useState, useMemo, useRef } from "react";
import Report from "../HomeScreenHeader/Reports/Report";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { postAPICall,setToastRef, showErrorToast, showToast} from "../../src/Api/Api.jsx";
import { InputText } from "primereact/inputtext";
import { debounce } from "lodash"; // Import lodash debounce function
import "./Style.css"; // Import your custom CSS file
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import * as XLSX from "xlsx"; // Import XLSX 
import { Toast } from "primereact/toast";
import { useLoader } from "../GlobalComponents/Loader.jsx";
export default function ScheduleInfo(props) {
  const No_Of_Days = parseInt(
    localStorage.getItem("SelectedAccountGroupAgainstDays"),
    10
  );
  console.log("No_Of_Days", No_Of_Days);
  const toast = useRef(null);
  // Initialize state with the parsed value or a default value
  const [Days, setDays] = useState(No_Of_Days || 10);
    const { showLoader, hideLoader } = useLoader();
  const [SchduleInfoData, setSchduleInfoData] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const AccountGroupCode = localStorage.getItem("AccountGroupCode");
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const calculateRowsPerPage = () => {
    const screenHeight = window.innerHeight;
    const rowHeight = 35; // Approximate height of each row in pixels (you can adjust this)
    const headerHeight = 100; // Estimated height for header, paginator, etc.

    const availableHeight = screenHeight - headerHeight;
    const calculatedRows = Math.floor(availableHeight / rowHeight);

    setRowsPerPage(calculatedRows);
  };
  useEffect(() => {
    setToastRef(toast.current);
    calculateRowsPerPage();
    window.addEventListener("resize", calculateRowsPerPage);
    return () => {
      window.removeEventListener("resize", calculateRowsPerPage);
    };
  }, []);

  const GetScheduleInfo = async () => {
    showLoader();
    setLoading(true);
    const RequestBody = {
      interval: Days,
      accountgroupcode: AccountGroupCode,
    };
    try {
      const response = await postAPICall(
        "api/Schedule/GetScheduleInfo",
        RequestBody
      );
      const data = response?.data || [];
      setSchduleInfoData(data);
      hideLoader()
      setTotalRowCount(data.length);
    } catch (error) {
      hideLoader()
      console.error("Error fetching schedule info:", error);
    } finally {
      hideLoader()
      setLoading(false); // Stop spinner after data load or error
    }
  };
  // Memoize filtered data based on search query and SchduleInfoData
  const filteredData = useMemo(() => {
    return SchduleInfoData?.filter((data) =>
      data.ScheduleName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [searchQuery, SchduleInfoData]);

  const rowClassName = (data) => {
    if (data.ScheduleCount < 6) {
      return "row-dark-red"; // Dark red for ScheduleCount less than 6
    } else if (data.ScheduleCount >= 6) {
      return "row-light-green"; // Light green for ScheduleCount equal to or greater than 6
    }
    return ""; // No class for other rows
  };
  const onRowDoubleClick = (e) => {
    props.onrowClick(e.data);
    navigate("/schedule");
  };
  const onCogIconClick = (rowData) => {
    props.onrowClick(rowData);
    navigate("/schedule");
    console.log("Clicked row data:", rowData);
    // You can perform any action here, like navigating to another page or displaying more details
  };
  const cogIconTemplate = (rowData) => {
    return (
      <i
        className="pi pi-spin pi-cog"
        style={{ cursor: "pointer" }} // Make the icon clickable
        onClick={() => onCogIconClick(rowData)} // Handle click and pass row data
      ></i>
    );
  };
  const exportExcel = () => {
    if (SchduleInfoData && SchduleInfoData.length > 0) {
    // Map the SchduleInfoData to only include fields to be exported
    const exportData = SchduleInfoData.map(({ ScheduleName, ScheduleCount, AccountGroupName }) => ({
      ScheduleName,
      ScheduleCount,
      AccountGroupName
    }));

    // Create a new worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ScheduleInfo");

    // Export the workbook to Excel file
    XLSX.writeFile(workbook, "ScheduleInfo.xlsx");
  }else{
    showErrorToast("No data to export.");
  }
  };
  return (
    <div>
      <Toast ref={toast} />
      <Report />
      <div className="flex-auto">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginLeft: "auto",
            marginTop: "10px",
          }}
        >
          <label
            htmlFor="minmax-buttons"
            id="ScheduleinfoLable"
            className="font-bold block mb-2"
            style={{ marginTop: "5px" }}
          >
            No of Days
          </label>
          <InputNumber
            style={{ marginLeft: "5px",height:"35px",marginTop:"5px" }}
            inputId="minmax"
            value={Days}
            onValueChange={(e) => setDays(e.value)}
            min={0}
            max={100}
          />
          <Button
            id="SchInfo-Btn"
            style={{ marginLeft: "10px", marginTop: "15px" }}
            onClick={GetScheduleInfo}
          >
            View
          </Button>
          <div style={{ display: "flex", marginLeft: "auto" }}>
            
            <InputText
              id="LibraryGridSeacrh"
              type="search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search..."
            />
            <Button
              icon="pi pi-search"
              style={{
                backgroundColor: "lightslategray",
                border: "lightslategray",
              }}
              id="LibraryGridSeacrhICon"
              className="p-button-primary"
              title="Search"
            />
            <Button
              id="ExportExcel"
              type="button"
              icon="pi pi-file-excel"
              severity="success"
              rounded
              title="Export Excel"
              onClick={exportExcel}
              data-pr-tooltip="XLS"
            />
          </div>
        </div>
      </div>

      {loading ? (
        <div className="spinner-container">
          <ProgressSpinner />
        </div>
      ) : (
        <DataTable
          paginator
          value={filteredData}
          rows={rowsPerPage}
          id="ScheduleinfoDatatable"
          scrollable
          scrollHeight="74vh"
          selectionMode={"single"}
          rowClassName={rowClassName} // Apply the rowClassName function
          onRowDoubleClick={onRowDoubleClick}
        >
          <Column
            field="ScheduleName"
            header="Name"
            sortable
            style={{ width: "10%" }}
          />
          <Column
            field="ScheduleCount"
            header="Count"
            sortable
            style={{ width: "10%" }}
          />
          <Column
            field="AccountGroupName"
            header="Name"
            sortable
            style={{ width: "5%" }}
          />
          <Column
            header="Actions"
            body={cogIconTemplate}
            style={{ width: "10%", textAlign: "left" }}
          />
        </DataTable>
      )}
      <div style={{ display: "flex", gap: "115px" }}>
        <b>Total Row Count: {totalRowCount}</b>
      </div>
    </div>
  );
}
